<template>
    <div>
        <test-template :testName="testName" :testId="testId" :test="test">
            <template #questions>
                <b-card class="neu-card" v-if="cQ && cQ.answer.length === 0">
                    <h2>{{cQ.question}}</h2>
                    <div >
                        <b-row>
                            <b-col class="d-flex justify-content-center">
                                <div class="d-inline-flex">
                                    <b-row>
                                        <b-col cols="12" sm="6" md="6" lg="6">
                                            <base-input class="inputAnswer" type="number" v-model="height" :placeholder="$t('tests.findrisk.heightPH')" min="1" max="250">
                                                <template slot="append">
                                                    <span>{{ $t('tests.findrisk.heightUnit') }}</span>
                                                </template>
                                            </base-input>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="6" lg="6">
                                            <base-input class="inputAnswer" type="number" v-model="weight" :placeholder="$t('tests.findrisk.weightPH')" min="1" step="0.1">
                                                <template slot="append">
                                                    <span>{{ $t('tests.findrisk.weightUnit') }}</span>
                                                </template>
                                            </base-input>
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col xs="12" lg="8" class="px-0 pt-1 px-md-5 pt-md-3 float-right m-auto">
                                <transition name="fade" appear>
                                    <button v-if="height && weight && weight != 0 && height != 0" type="button" class="btn btn-primary w-100" @click.once="saveIMC">
                                        <span class="text-center">{{ $t('tests.findrisk.IMC') }}: {{ calculateIMC }}</span>
                                        <span class="float-right m-auto"><base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" color="white"/></span>
                                    </button>
                                </transition>
                            </b-col>
                        </b-row>
                    </div>
                </b-card>
                <question-card :question="cQ" labelsEnabled v-model="questionResult" v-else :progress="$store.state.tests.currentSlide" stacked :questionnaireLength="$store.state.tests.test.length"  @answerQuestion="() => { $store.commit('tests/incrementSlide') }" @submitQuestionnaire="saveTestResults"></question-card>
            </template>
            <template #results>
                <div class="first">
                    <h3 class="subtitle-card text-center">{{ $t('tests.testResults') }} - {{ testName.toUpperCase() }}</h3>
                </div>
                <div class="second">
                    <b-card class="neu-card pt-0 col-lg-7 h-auto mean-result bg-warning">
                        <p class="card-text text-justify" v-html="$t(`tests.findrisk.cantReplaceDiagnosis`)"></p>
                    </b-card>
                    <b-card class="neu-card col-lg-7 h-auto mean-result">
                        <h3 class="subtitle-card d-block"> {{ testName }}</h3>
                        <h5 class="subtitle-card d-block" :style="`color: ${resultInfo.color}`"> {{ resultInfo.tag.toUpperCase() }}</h5>
                        <p v-if="DBResults.generalResult >= 15" class="p-white" v-html="$t(`tests.findrisk.tips.highRiskTip`)"></p>
                    </b-card>
                    <b-row>
                        <b-row v-for="n in 3" :key="n" class="col-lg-4 results-card px-2">
                                <b-card class="neu-card">
                                    <base-icon :src="`/static-appopensalud/img/icons/morillas-svg-icons/primary/findRisktip${n}.svg`" alt="" :height="iconSize" :width="iconSize" color="blue" :class="{ 'd-inline-block': $uiHelpers.isMobile }"></base-icon>
                                    <p class="card-text text-justify" v-html="$t(`tests.findrisk.tips.tip${n}`)"></p>
                                </b-card>
                        </b-row>
                    </b-row>
                </div>
            </template>
        </test-template>
    </div>
</template>

<script>
import TestTemplate from './TestTemplate.vue'
import BaseInput from '@/components/base/forms/BaseInput.vue'
import { TEST_FINDRISK } from '@/constants/patientServices'
import BaseRadioGroup from '@/components/base/forms/BaseRadioGroup.vue'
import selfEvaluationTestMixin from '@/mixins/selfEvaluationTest.mixin'
import ClinicHistoryRepository from '@/repositories/ClinicHistoryRepository'

export default {
    mixins: [selfEvaluationTestMixin],
    components: {
        'test-template': TestTemplate,
        BaseInput,
        'radio-button': BaseRadioGroup
    },
    data () {
        const test = [
            {
                id: 'q1',
                question: this.$t('tests.findrisk.questions.q1'),
                answer: [
                    {value: 0, text: this.$t('tests.answers.lessThan45')},
                    {value: 2, text: this.$t('tests.answers.45to54')},
                    {value: 3, text: this.$t('tests.answers.55to64')},
                    {value: 4, text: this.$t('tests.answers.moreThan64')}
                ],
                result: null
            },
            {
                id: 'q2',
                question: this.$t('tests.findrisk.questions.q2'),
                answer: [],
                result: null
            },
            {
                id: 'q3',
                question: this.$t('tests.findrisk.questions.q3'),
                answer: this.$store.state.session.user.sex === 'H' ? [
                    {value: 0, text: this.$t('tests.answers.lessThan94')},
                    {value: 1, text: this.$t('tests.answers.94to102')},
                    {value: 3, text: this.$t('tests.answers.moreThan102')}
                ] : this.$store.state.session.user.sex === 'M' ? [
                    {value: 0, text: this.$t('tests.answers.lessThan80')},
                    {value: 1, text: this.$t('tests.answers.80to88')},
                    {value: 3, text: this.$t('tests.answers.moreThan88')}
                ] : [
                    {value: 0, text: `${this.$t('tests.answers.man')}: ${this.$t('tests.answers.lessThan94')}`},
                    {value: 1, text: `${this.$t('tests.answers.man')}: ${this.$t('tests.answers.94to102')}`},
                    {value: 3, text: `${this.$t('tests.answers.man')}: ${this.$t('tests.answers.moreThan102')}`},
                    {value: 0, text: `${this.$t('tests.answers.woman')}: ${this.$t('tests.answers.lessThan80')}`},
                    {value: 1, text: `${this.$t('tests.answers.woman')}: ${this.$t('tests.answers.80to88')}`},
                    {value: 3, text: `${this.$t('tests.answers.woman')}: ${this.$t('tests.answers.moreThan88')}`}
                ],
                result: null
            },
            {
                id: 'q4',
                question: this.$t('tests.findrisk.questions.q4'),
                answer: [
                    {value: 0, text: this.$t('tests.answers.yes')},
                    {value: 2, text: this.$t('tests.answers.no')}
                ],
                result: null
            },
            {
                id: 'q5',
                question: this.$t('tests.findrisk.questions.q5'),
                answer: [
                    {value: 1, text: this.$t('tests.answers.yes')},
                    {value: 0, text: this.$t('tests.answers.no')}
                ],
                result: null
            },
            {
                id: 'q6',
                question: this.$t('tests.findrisk.questions.q6'),
                answer: [
                    {value: 2, text: this.$t('tests.answers.yes')},
                    {value: 0, text: this.$t('tests.answers.no')}
                ],
                result: null
            },
            {
                id: 'q7',
                question: this.$t('tests.findrisk.questions.q7'),
                answer: [
                    {value: 5, text: this.$t('tests.answers.yes')},
                    {value: 0, text: this.$t('tests.answers.no')}
                ],
                result: null
            },
            {
                id: 'q8',
                question: this.$t('tests.findrisk.questions.q8'),
                answer: [
                    {value: 5, text: this.$t('tests.answers.yesCloseFamily')},
                    {value: 3, text: this.$t('tests.answers.yesNotCloseFamily')},
                    {value: 0, text: this.$t('tests.answers.no')}
                ],
                result: null
            }
        ]

        return {
            test: test,
            testId: TEST_FINDRISK,
            testName: this.$t('tests.findrisk.title'),
            iconSize: this.$uiHelpers.isMobile ? '40' : '50',
            weight: null,
            height: null
        }
    },
    created () {
        this.clinicHistoryRepository.getAllVariables().then((r) => {
            this.weight = r.data.data.basicVariables.weight.values[0] === 0 ? null : r.data.data.basicVariables.weight.values[0]
            this.height = r.data.data.basicVariables.height.values[0] === 0 ? null : r.data.data.basicVariables.height.values[0]
        })
    },
    methods: {
        saveTestResults () {
            const result = this.test.map(x => x.result).reduce((a, b) => a + b, 0)
            this.save(null, result, this.percentResult(result, 25))
        },
        saveIMC () {
            this.saveClinicHistoryValue(this.weight, 'weight')
            this.saveClinicHistoryValue(this.height, 'height')
            var imc = Math.round(this.weight / Math.pow(this.height / 100, 2) * 100) / 100
            this.cQ.result = imc > 30 ? 3 : imc < 25 ? 0 : 1
            if (this.$store.state.tests.currentSlide <= this.test.length - 2) {
                this.$store.commit('tests/incrementSlide')
            } else {
                this.saveTestResults()
            }
        },
        saveClinicHistoryValue (value, variableName) {
            var data = { aspNetUserId: this.$store.state.session.user.id, datetime: new Date(), id: null, petId: null, trackingCreated: false, values: [value], variableName: variableName }
            this.clinicHistoryRepository.saveVariableValue(data)
        }
    },
    computed: {
        clinicHistoryRepository () {
            return ClinicHistoryRepository(this.$route.query)
        },
        calculateIMC () {
            return Math.round(this.weight / Math.pow(this.height / 100, 2) * 100) / 100
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/views/selfEvaluationTests/FindRiskTest.vue